var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('EcsSearchInput',{ref:"searchBox",staticClass:"pa-4",attrs:{"sync":_vm.syncSearch,"placeholder":_vm.searchPlaceholder},on:{"search-input-changed":_vm.handleSearch}}),_vm._t("toolbar"),_c('div',{ref:"listContainer",staticClass:"custom-scrollbar side-bar-list-container"},[_vm._t("default")],2)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }